module.exports = JSON.parse('{"languageSwitcher":{"label":"Til"},"close":"Yopish","pageTitle":"Yangi yil 2027 — Ortiqcha yo\'q! | NL International"}')